
export const API_URL = '/api/';
export const PAGE_SIZE = 6;
export const TIMEZONE: any[] = [
  { id: 1, name: 'Etc/GMT+12', gmt: '(GMT-12:00)' },
  { id: 2, name: 'Pacific/Midway', gmt: '(GMT-11:00)' },
  { id: 3, name: 'Pacific/Adak', gmt: '(GMT-10:00)' },
  { id: 4, name: 'US/Alaska', gmt: '(GMT-9:00)' },
  { id: 5, name: 'America/Dawson', gmt: '(GMT-8:00)' },
  { id: 6, name: 'America/Boise', gmt: '(GMT-7:00)' },
  { id: 7, name: 'America/Chicago', gmt: '(GMT-6:00)' },
  { id: 8, name: 'America/Toronto', gmt: '(GMT-5:00)' },
  { id: 9, name: 'America/Halifax', gmt: '(GMT-4:00)' },
  { id: 10, name: 'America/Bahia', gmt: '(GMT-3:00)' },
  { id: 11, name: 'America/Noronha', gmt: '(GMT-2:00)' },
  { id: 12, name: 'Atlantic/Azores', gmt: '(GMT-1:00)' }
];

export const FILETYPE: any[] = [
  { id: 1, name: 'Androdid APK' },
  { id: 2, name: 'IOS IPA'}
];

